// @flow
import * as React from "react";

import { useSelector } from "react-redux";

import currencyFormatter from "utils/formatters/currency";

import type { State as AffiliateBalanceState } from "state/reducers/affiliateBalance";

type State = {
  affiliateBalance: AffiliateBalanceState,
};

function AffiliateBalance(): React.Node {
  const balance = useSelector<State, number>((state) => state.affiliateBalance.value);

  return <span>Balance: {currencyFormatter(balance / 100)}</span>;
}

export default AffiliateBalance;
